import { gql } from '@apollo/client';
import {
  CHAIN_BASE_FRAGMENT,
  CHAIN_FRAGMENT,
  CHAIN_MAPPING_FRAGMENT,
} from 'graphql/secure/fragments/chain.fragments';

export const GET_CHAIN_MAPPING = gql`
  query GetChainMapping($id: UUID!, $lang: Language) {
    chain(id: $id, lang: $lang) {
      ...chainMappingValues
    }
  }
  ${CHAIN_MAPPING_FRAGMENT}
`;

export const GET_CHAIN = gql`
  query GetChain($id: UUID!, $lang: Language) {
    chain(id: $id, lang: $lang) {
      ...chainValues
    }
  }
  ${CHAIN_FRAGMENT}
`;

export const GET_BASE_CHAIN = gql`
  query GetBaseChain($id: UUID!) {
    chain(id: $id) {
      ...chainBaseValues
    }
  }
  ${CHAIN_BASE_FRAGMENT}
`;

export const GET_CHAINS_INCLUDING_CHAIN = gql`
  query GetChainsIncludingChain($id: UUID!) {
    chainsIncludingChain(id: $id) {
      chain {
        ...chainBaseValues
      }
      depth
    }
  }
  ${CHAIN_BASE_FRAGMENT}
`;

/**
 * Returns a list of all base component chains (or a specific from a specific component)
 * @type COMPONENT_CHAIN_BASE_FRAGMENT
 */
export const GET_CHAINS = gql`
  query GetChains(
    $filters: ChainsFilters
    $first: Int
    $after: String
    $before: String
    $orderBy: ChainsOrderBy
  ) {
    chains(filters: $filters, first: $first, after: $after, before: $before, orderBy: $orderBy) {
      pageInfo {
        hasNextPage
        endCursor
        startCursor
        hasPreviousPage
      }
      edges {
        node {
          ...chainBaseValues
        }
      }
    }
  }
  ${CHAIN_BASE_FRAGMENT}
`;

/**
 * Returns a component chain for the onboarding process depending on the onboarding step.
 * client-side only (see resolvers)
 * @param id The id of the component chain
 * @param onboardingStep The onboarding step
 * @type COMPONENT_CHAIN_FRAGMENT
 */
export const GET_ONBOARDING_CHAIN = gql`
  query GetOnboardingChain($id: UUID!, $onboardingStep: Int!) {
    onboardingChain(id: $id, onboardingStep: $onboardingStep) @client {
      ...chainMappingValues
    }
  }
  ${CHAIN_MAPPING_FRAGMENT}
`;
